var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _style2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoadingGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlnsGraph: "http://ns.adobe.com/Graphs/1.0/",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 130.6 134",
    style: {
      enableBackground: "new 0 0 130.6 134"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#00A959;}\n\t.st1{fill:#BADBC6;}\n\t.st2{fill:#2AB56B;}\n\t.st3{fill:#D4E2D8;}\n\t.st4{fill:#58BD82;}\n\t.st5{fill:#E5E5E5;}\n\t.st6{fill:#8FCEA7;}\n\t.st7{fill:#F1F0F2;}\n")), /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", {
    style: {
      transform: "rotateZ(469deg)",
      transformOrigin: "50%"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M81,21.2c0,7.6-6.1,13.7-13.7,13.7c-7.5,0-13.7-6.1-13.7-13.7c0-7.6,6.1-13.7,13.7-13.7    C74.8,7.5,81,13.6,81,21.2L81,21.2z M81,21.2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M75.5,116.3c0,4.5-3.7,8.2-8.2,8.2c-4.5,0-8.2-3.7-8.2-8.2c0-4.5,3.7-8.2,8.2-8.2    C71.8,108.1,75.5,111.8,75.5,116.3L75.5,116.3z M75.5,116.3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M45.9,35.1c0,6.8-5.5,12.3-12.3,12.3c-6.8,0-12.3-5.5-12.3-12.3c0-6.8,5.5-12.3,12.3-12.3    C40.4,22.8,45.9,28.3,45.9,35.1L45.9,35.1z M45.9,35.1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M107.8,102.4c0,3.8-3.1,6.9-6.9,6.9c-3.8,0-6.8-3.1-6.8-6.9c0-3.8,3.1-6.8,6.8-6.8    C104.7,95.5,107.8,98.6,107.8,102.4L107.8,102.4z M107.8,102.4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M30.7,68.8c0,6-4.9,10.9-11,10.9c-6.1,0-11-4.9-11-10.9c0-6.1,4.9-11,11-11C25.8,57.8,30.7,62.7,30.7,68.8    L30.7,68.8z M30.7,68.8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M120.3,68.7c0,3-2.5,5.5-5.5,5.5c-3,0-5.5-2.5-5.5-5.5c0-3,2.4-5.5,5.5-5.5C117.9,63.3,120.3,65.7,120.3,68.7    L120.3,68.7z M120.3,68.7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M26.9,95.6c-3.8,3.8-3.8,9.8,0,13.6c3.7,3.7,9.8,3.7,13.6,0c3.7-3.8,3.7-9.8,0-13.6    C36.7,91.9,30.6,91.8,26.9,95.6L26.9,95.6z M26.9,95.6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M105,35.1c0,2.3-1.8,4.1-4.1,4.1c-2.3,0-4.1-1.8-4.1-4.1c0-2.3,1.8-4.1,4.1-4.1C103.2,31,105,32.8,105,35.1    L105,35.1z M105,35.1"
  })))), _style2 || (_style2 = /*#__PURE__*/React.createElement("style", {
    xmlns: "http://www.w3.org/1999/xhtml",
    type: "text/css"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingGreen);
export default __webpack_public_path__ + "static/media/loading_green.f54bca84921713987e4047592f006da2.svg";
export { ForwardRef as ReactComponent };